<template>
    <div class="con-list-box">
        <div v-for="(item, index) in conData" :key="index" class="item">
            <div class="topImg"></div>
            <div class="item-content">
                <div class="left">
                    <span class="rmb">￥</span>
                    <span class="num">{{ item.pledgeMoney }}</span>
                </div>
                <div class="right">
                    <div class="l-top">
                        <h3 class="title">顺丰优惠券</h3>
                        <p>
                            <span>券号：</span>
                            <span>{{ item.couponNo }}</span>
                        </p>
                        <p>
                            <span>券码：</span>
                            <span>{{ item.checkCode }}</span>
                        </p>
                        <p class="time">
                            <span>有效期至</span>
                            <span>{{ item.invalidDate }}</span>
                        </p>
                    </div>
                    <div class="l-footer">
                        <span>{{ item.couponDesc }}</span>
                    </div>
                </div>
            </div>
            <div class="barCode" @click="showCouponDetail(item.couponNo, item.checkCode, item.pledgeMoney)">
                <div class="code">
                    <img id="linecode" alt="code图标" />
                </div>
                <p>点击放大</p>
            </div>
        </div>
        <p class="no-more">没有更多了</p>
        <Detail v-if="showDetail" :coupno="isCouponNo" :check="isCheckCode" :m="isMoney" @close="showDetail = false"></Detail>
    </div>
</template>
<script>
import ajax from '@/api/ajax'
import JsBarcode from 'jsbarcode'
import Detail from './components/detail'
export default {
    components: {
        Detail
    },
    data() {
        return {
            // 数据源
            conData: [],
            showDetail: false,
            isCouponNo: null,
            isCheckCode: null,
            isMoney: null,
            showImg: false
        }
    },
    created() {
        // 获取数据
        const params = {
            customerTel: sessionStorage.getItem('customerTel'), // 手机号
            couponType: 1, // 优惠卷类型
            status: 0 // 优惠卷状态
        }
        const headers = {
            'SMS-Verification-App': 'coupon',
            'SMS-Verification-Code': sessionStorage.getItem('yzCode'),
            'SMS-Verification-Mobile': params.customerTel
        }
        ajax.getCoupons({ params, headers })
            .then(res => {
                const { data } = res
                if (data.code === 113) {
                    this.$toast('请重新获取验证码')
                    this.$router.push({ name: 'couponslogin' })
                }
                if (data.code === 0) {
                    this.conData = data.result
                    this.showImg = true
                }
            })
            .catch(res => {
                this.$toast('网络异常，稍后重试')
            })
    },
    mounted() {
        setTimeout(() => {
            if (this.showImg && this.conData.length != 0) {
                JsBarcode('#linecode', 'SF', { displayValue: false })
            }
        }, 1000)
    },
    methods: {
        showCouponDetail(couponNo, checkCode, m) {
            this.showDetail = true
            this.isCouponNo = couponNo
            this.isCheckCode = checkCode
            this.isMoney = m
        }
    }
}
</script>
<style lang="scss" scoped>
.con-list-box {
    overflow: hidden;
    .item {
        width: 7.12rem;
        height: 3.1rem;
        box-sizing: border-box;
        border: 1px solid #d2d2d2;
        border-radius: 0.1rem;
        margin: 0 auto;
        padding-right: 0.3rem;
        position: relative;
        margin-top: 0.18rem;
        .topImg {
            width: 7.1rem;
            height: 0.31rem;
            background: url('../../assets/images/coupons/web_pic_red.png') no-repeat top;
            background-size: cover;
        }
        .item-content {
            width: 100%;
            height: 2.74rem;
            overflow: hidden;
            display: flex;
            .left {
                width: 2.8rem;
                height: 100%;
                padding-left: 0.6rem;
                padding-top: 0.8rem;
                color: #e73248;
                .rmb {
                    font-size: 0.36rem;
                }
                .num {
                    font-size: 0.93rem;
                }
            }
            .right {
                flex: 1;
                display: flex;
                flex-direction: column;
                margin-left: -0.2rem;
                .l-top {
                    flex: 1;
                    .title {
                        font-size: 0.3rem;
                        line-height: 0.76rem;
                        height: 0.76rem;
                    }
                    p {
                        font-size: 0.23rem;
                    }
                    .time {
                        color: #666;
                        line-height: 2;
                    }
                }
                .l-footer {
                    height: 0.7rem;
                    border-top: 1px solid #d2d2d2;
                    font-size: 0.26rem;
                    line-height: 0.7rem;
                    text-align: right;
                    color: #f58c32;
                }
            }
        }
        .barCode {
            width: 1.2rem;
            position: absolute;
            top: 0.43rem;
            right: 0.13rem;
            .code {
                height: 0.58rem;
                margin-bottom: 0.21rem;
                #linecode {
                    width: 100%;
                    height: 100%;
                }
            }
            p {
                font-size: 0.24rem;
                color: #666;
                margin-top: 0.4rem;
            }
        }
    }
    .no-more,
    .toFail {
        font-size: 26px;
        color: #666;
        margin-top: 0.28rem;
        text-align: center;
    }
    .toFail {
        color: #09f;
        margin-top: 0.36rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/coupons/general.vue